import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

function Row({ c, canEdit, reload }) {
  const [name, setName] = useState(c.name);
  const run = async (fn, msg) => { try { await fn(); toast.success(msg); reload(); } catch (e) { toast.error(apiError(e)); } };
  return (
    <tr data-testid={`category-row-${c.name}`}>
      <td>{canEdit ? <input value={name} onChange={(e) => setName(e.target.value)} className="h-8 px-2 rounded border border-slate-200 text-[13px] w-56" data-testid={`category-name-${c.name}`} /> : c.name}</td>
      <td className="text-right font-mono" data-testid={`category-count-${c.name}`}>{c.product_count}</td>
      <td><span className={`text-[11px] px-1.5 py-0.5 rounded border ${c.active ? "bg-emerald-50 text-emerald-700 border-emerald-200" : "bg-slate-100 text-slate-500 border-slate-200"}`}>{c.active ? "Aktif" : "Pasif"}</span></td>
      {canEdit && <td className="text-right space-x-1 whitespace-nowrap">
        {name.trim() !== c.name && <Button size="sm" variant="outline" className="h-7" onClick={() => run(() => api.put(`/product-categories/${c.id}`, { name }), "Yeniden adlandırıldı")} data-testid={`category-rename-${c.name}`}>Kaydet</Button>}
        <Button size="sm" variant="outline" className="h-7" onClick={() => run(() => api.put(`/product-categories/${c.id}`, { active: !c.active }), c.active ? "Pasife alındı" : "Aktifleştirildi")} data-testid={`category-toggle-${c.name}`}>{c.active ? "Pasife Al" : "Aktifleştir"}</Button>
        <Button size="sm" variant="outline" className="h-7 text-rose-700" onClick={() => run(() => api.delete(`/product-categories/${c.id}`), "Silindi")} data-testid={`category-delete-${c.name}`}>Sil</Button>
      </td>}
    </tr>
  );
}

export default function CategoriesTab() {
  const { can } = useAuth();
  const canEdit = can("ayarlar", "kategori");
  const [d, setD] = useState(null);
  const [name, setName] = useState("");
  const load = useCallback(() => api.get("/product-categories").then(({ data }) => setD(data)), []);
  useEffect(() => { load(); }, [load]);
  const add = async () => {
    try { await api.post("/product-categories", { name }); setName(""); toast.success("Kategori eklendi"); load(); } catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div className="panel p-4 space-y-3" data-testid="categories-tab">
      <div className="text-sm text-slate-600">Kullanılan kategori silinemez; pasife alınabilir. Pasif kategori yeni atamalarda seçilemez, mevcut ürünler ve raporlar korunur.</div>
      {canEdit && <div className="flex gap-2"><input value={name} onChange={(e) => setName(e.target.value)} placeholder="Yeni kategori adı" className="h-9 px-2 rounded-md border border-slate-300 text-sm w-64" data-testid="category-new-input" />
        <Button size="sm" disabled={!name.trim()} onClick={add} className="bg-blue-600 hover:bg-blue-700" data-testid="category-add-button">Ekle</Button></div>}
      <table className="erp-table"><thead><tr><th>Kategori</th><th className="text-right">Ürün</th><th>Durum</th>{canEdit && <th></th>}</tr></thead>
        <tbody>{d?.items.map((c) => <Row key={`${c.id}-${c.name}-${c.active}`} c={c} canEdit={canEdit} reload={load} />)}
          {d && <tr><td className="text-slate-500">Kategorisiz</td><td className="text-right font-mono" data-testid="category-uncategorized-count">{d.uncategorized_count}</td><td></td>{canEdit && <td></td>}</tr>}</tbody></table>
    </div>
  );
}
